export default {
  selectTable : null,
  selectionLongTouch : null,
  timeOut : null,
  selectionLongTouchTimeOut : null,
  addClickHandler(object, cb){
    object.on('mousedown', () => {
      cb(object)
    });
  },
  addDbClickHandler(table, cb){
    let object = table.canvasObject;
    object.off('mousedown')
    object.on('mousedown', (event) => {
      event.e.preventDefault();
      event.e.stopPropagation();
      if(this.selectTable === object){
        clearTimeout(this.timeOut)
        this.selectTable = null;
        cb(table)
        return
      }
      this.selectTable = object;
      this.timeOut = setTimeout(() => {
        this.selectTable = null;
      }, 1200);
    });
  },

  addLongTouch(table, cb){
    let object = table.canvasObject;
    object.off('mousedown')
    object.off('mouseup')

    object.on('mousedown', (event) => {

      event.e.preventDefault();
      event.e.stopPropagation();

      this.selectionLongTouchTimeOut = setTimeout(() => {
        this.selectionLongTouch = object;
      }, 700);

      object.on('mouseup', (event2) => {
        object.off('mouseup')
        clearTimeout(this.selectionLongTouchTimeOut)
        if(object === this.selectionLongTouch){
          cb(table);
        }
        event2.e.preventDefault();
        event2.e.stopPropagation();
      });

    });
  }
}
